function initSeoGeoCompetitorReportForm() {
  const form = document.querySelector("#av-form");
  if (!form || form.dataset.avBound) return;

  const card = form.closest(".av-form-card");
  const submitButton = form.querySelector(".av-btn");
  const networkError = form.querySelector("#av-form-error");
  const checkbox = form.querySelector("#av-check-gdpr");
  const leadRefInput = form.querySelector("#av-lead-ref");

  const fields = {
    businessSector: {
      el: form.querySelector("#av-sector"),
      validate: (value) => value.trim().length > 0,
      message: "Seleziona il settore in cui operi.",
      errorId: "av-error-business-sector"
    },
    clientUrl: {
      el: form.querySelector("#av-client-url"),
      validate: (value) => isValidUrl(value),
      message: "Inserisci l'URL completo del tuo sito.",
      errorId: "av-error-client-url"
    },
    competitor1Url: {
      el: form.querySelector("#av-comp1"),
      validate: (value) => isValidUrl(value),
      message: "Inserisci l'URL completo del competitor principale.",
      errorId: "av-error-competitor-1-url"
    },
    competitor2Url: {
      el: form.querySelector("#av-comp2"),
      validate: (value) => value.trim() === "" || isValidUrl(value),
      message: "Inserisci un URL valido oppure lascia il campo vuoto.",
      errorId: "av-error-competitor-2-url"
    },
    competitor3Url: {
      el: form.querySelector("#av-comp3"),
      validate: (value) => value.trim() === "" || isValidUrl(value),
      message: "Inserisci un URL valido oppure lascia il campo vuoto.",
      errorId: "av-error-competitor-3-url"
    }
  };

  const requiredNodes = [
    submitButton,
    checkbox,
    leadRefInput,
    fields.businessSector.el,
    fields.clientUrl.el,
    fields.competitor1Url.el,
    fields.competitor2Url.el,
    fields.competitor3Url.el
  ];

  if (requiredNodes.some((node) => !node)) return;
  form.dataset.avBound = "true";

  function isValidUrl(value) {
    try {
      const url = new URL(value.trim());
      return url.protocol === "http:" || url.protocol === "https:";
    } catch (_) {
      return false;
    }
  }

  function setFieldError(errorId, message) {
    const errorElement = form.querySelector(`#${errorId}`);
    if (!errorElement) return;
    errorElement.textContent = message || "";
    errorElement.hidden = !message;
  }

  function setCheckboxError(message) {
    setFieldError("av-error-consent-gdpr", message);
    checkbox?.nextElementSibling?.classList.toggle("ct-check-invalid", !!message);
  }

  function escapeHtml(value) {
    return String(value || "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#39;");
  }

  function renderSuccessState(data) {
    if (!card) return;

    const title = escapeHtml(data.message_title || "Report richiesto con successo");
    const body = escapeHtml(data.message_body || "Complimenti, abbiamo preso in carico il tuo Competitor Intelligence Report. Te lo presenteremo in video call con un nostro consulente dedicato.");
    const note = escapeHtml(data.message_note || "Riceverai i prossimi aggiornamenti via email.");

    card.innerHTML = `
      <div class="ct-success-panel" aria-live="polite">
        <div class="ct-success-icon" aria-hidden="true">
          <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="24" cy="24" r="23" stroke="currentColor" stroke-width="1.5"></circle>
            <path d="M13 24.5L20.5 32L35 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </div>
        <p class="ct-success-eyebrow">Competitor report prenotato</p>
        <h3 class="ct-success-title">${title}</h3>
        <p class="ct-success-body">${body.replaceAll("\n", "<br>")}</p>
        <p class="av-form-note">${note}</p>
      </div>
    `;
  }

  function clearAllErrors() {
    Object.values(fields).forEach(({ el, errorId }) => {
      el?.classList.remove("ct-invalid");
      setFieldError(errorId, "");
    });
    setCheckboxError("");
    if (networkError) {
      networkError.textContent = "";
      networkError.hidden = true;
    }
  }

  Object.values(fields).forEach(({ el, validate, message, errorId }) => {
    if (!el) return;
    el.addEventListener("blur", () => {
      const valid = validate(el.value);
      el.classList.toggle("ct-invalid", !valid);
      setFieldError(errorId, valid ? "" : message);
    });
    el.addEventListener("input", () => {
      el.classList.remove("ct-invalid");
      setFieldError(errorId, "");
    });
  });

  checkbox?.addEventListener("change", () => setCheckboxError(""));

  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    clearAllErrors();

    if (!leadRefInput.value.trim()) {
      if (networkError) {
        networkError.textContent = "Il link del report e scaduto. Torna al form di contatto per riattivarlo.";
        networkError.hidden = false;
      }
      return;
    }

    let firstInvalid = null;
    let valid = true;

    Object.values(fields).forEach(({ el, validate, message, errorId }) => {
      if (!el) return;
      const fieldValid = validate(el.value);
      if (!fieldValid) {
        el.classList.add("ct-invalid");
        setFieldError(errorId, message);
        firstInvalid ||= el;
        valid = false;
      }
    });

    if (!checkbox?.checked) {
      setCheckboxError("Devi autorizzare il trattamento dei dati per ricevere il report.");
      valid = false;
    }

    if (!valid) {
      firstInvalid?.focus();
      return;
    }

    submitButton.disabled = true;

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") || "";
    const payload = {
      report: {
        lead_ref: leadRefInput.value.trim(),
        business_sector: fields.businessSector.el?.value.trim(),
        client_url: fields.clientUrl.el?.value.trim(),
        competitor_1_url: fields.competitor1Url.el?.value.trim(),
        competitor_2_url: fields.competitor2Url.el?.value.trim(),
        competitor_3_url: fields.competitor3Url.el?.value.trim(),
        consent_gdpr: String(checkbox.checked)
      }
    };

    try {
      const response = await fetch(form.dataset.url || form.action, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": csrfToken
        },
        body: JSON.stringify(payload)
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        if (networkError) {
          networkError.textContent = data.error || "Si e verificato un errore. Riprova tra poco.";
          networkError.hidden = false;
        }
        return;
      }

      renderSuccessState(data);
    } catch (_) {
      if (networkError) {
        networkError.textContent = "Errore di rete. Controlla la connessione e riprova.";
        networkError.hidden = false;
      }
    } finally {
      submitButton.disabled = false;
    }
  });
}

function initSeoGeoCompetitorReportStatus() {
  const statusNode = document.querySelector("#seo-geo-competitor-report-status");
  if (!statusNode || statusNode.dataset.pollBound) return;
  if (!["queued", "processing"].includes(statusNode.dataset.status || "")) return;

  statusNode.dataset.pollBound = "true";
  const messageNode = document.querySelector("#seo-geo-competitor-report-message");

  const poll = async () => {
    try {
      const response = await fetch(statusNode.dataset.pollUrl, {
        headers: { Accept: "application/json" }
      });
      if (!response.ok) return;

      const data = await response.json();
      if (data.completed) {
        window.location.reload();
        return;
      }

      if (data.status === "failed") {
        if (messageNode) {
          messageNode.textContent = data.error || "La generazione del report non e andata a buon fine.";
        }
        statusNode.dataset.status = "failed";
        return;
      }

      window.setTimeout(poll, 3000);
    } catch (_) {
      window.setTimeout(poll, 5000);
    }
  };

  window.setTimeout(poll, 3000);
}

document.addEventListener("turbo:load", () => {
  initSeoGeoCompetitorReportForm();
  initSeoGeoCompetitorReportStatus();
});

if (document.readyState !== "loading") {
  initSeoGeoCompetitorReportForm();
  initSeoGeoCompetitorReportStatus();
}
